/**
 * Permission constants and types
 *
 * This file defines all available permissions in the system.
 * Permissions are validated against the `permissions` database table,
 * but these constants serve as the TypeScript source of truth.
 */
/**
 * All available permission names
 */
export const PERMISSIONS = [
    'manage_organization',
    'manage_members',
    'manage_projects',
    'manage_all_projects',
    'view_projects',
    'view_all_projects',
    'manage_lists',
    'view_reports',
    'ai_image_analysis',
    'confirm_overtime',
    'export_data',
    'publish_to_reels',
];
/**
 * Permission categories for grouping
 */
export const PERMISSION_CATEGORIES = {
    ORGANIZATION: 'organization',
    MEMBERS: 'members',
    PROJECTS: 'projects',
    LISTS: 'lists',
    REPORTS: 'reports',
    AI: 'ai',
    REELS: 'reels',
};
/**
 * Default role permissions mapping
 * Used as fallback when organization-specific permissions are not available
 */
export const ROLE_PERMISSIONS = {
    owner: [
        'manage_organization',
        'manage_members',
        'manage_projects',
        'manage_all_projects',
        'view_projects',
        'view_all_projects',
        'manage_lists',
        'view_reports',
        'ai_image_analysis',
        'confirm_overtime',
        'export_data',
        'publish_to_reels',
    ],
    admin: [
        'manage_members',
        'manage_projects',
        'manage_all_projects',
        'view_projects',
        'view_all_projects',
        'manage_lists',
        'view_reports',
        'ai_image_analysis',
        'export_data',
        'publish_to_reels',
    ],
    architect: [
        'manage_projects',
        'view_projects',
        'manage_lists',
        'view_reports',
        'ai_image_analysis',
    ],
    contractor: [
        'view_projects',
        // Note: contractors resolve permissions from contractor_permissions table.
    ],
    watcher: [
        'view_projects',
    ],
    business_owner: [
        'view_projects',
        'confirm_overtime',
    ],
    user: [
        'manage_projects',
        'view_projects',
        'manage_lists',
        'view_reports',
        'ai_image_analysis',
        'publish_to_reels',
    ],
    viewer: [
        'view_projects',
        'view_reports',
    ],
};
/**
 * Helper function to check if a string is a valid permission
 */
export function isValidPermission(permission) {
    return PERMISSIONS.includes(permission);
}
/**
 * Helper function to get all permissions for a role
 */
export function getRolePermissions(role) {
    return ROLE_PERMISSIONS[role] || [];
}
